module.exports = __webpack_public_path__ + "assets/img/home-dfzq.507149c3.png";